import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetSignUpLink() {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/sign-up`;
}
